import React, {useState, useEffect} from 'react'
import styles from './styles.module.scss'
import {connect} from 'react-redux'
import {getGrantsTerms, getGrantsOptions, editGrantsOptions} from '../../../actions/grants'
import {GRANTS_OPTIONS} from '../../../actions/types'
import {store} from '../../App';
import moment from 'moment'
import Loader from 'react-loader';
import { createNotification } from '../../notifications/notifications'
import Selector from '../../shared/Selector'
import { educationLevelsReNames } from '../../../utils/const'

const dateFormat = 'YYYY-MM-DD'

const mapStateToProps = ({grants}) => {
    const {terms, options, loading_options} = grants
    return {terms, options, loading_options}
}

const Index = ({
    terms,
    getGrantsTerms,
    getGrantsOptions,
    editGrantsOptions,
    year,
    setIsPopup,
    options,
    loading_options,
    yearsLocal,
    setYear
}) => {

    const [optionsLocal,
        setOptionsLocal] = useState(null);
    const [isTermPopup,
        setIsTermPopup] = useState(null) ;

    const handleGetTerms = (type, date) => {
        if (date.date_to != null && date.date_to != '' && date.date_to != 'Invalid date') {
            getGrantsTerms(type, date);
        }
    }

    useEffect(() => {
        if (Object.keys(terms).length === 0) {
            return;
        }
    
        const newOptions = optionsLocal?.map(item => 
            item.id == terms.type ? ({
                ...item,
                trmids: item.trmids
                    // Оставляем только те, которые есть в terms.date
                    .filter(existing => terms.date.some(t => t.trmid === existing.trmid))
                    // Добавляем новые, которых еще нет
                    .concat(
                        terms.date
                            .filter(t => !item.trmids.some(existing => existing.trmid === t.trmid))
                            .map(t => ({ ...t, isChecked: false }))
                    )
            }) : item
        );
    
        setOptionsLocal(newOptions);
    }, [terms]);
    

    useEffect(() => {
        getGrantsOptions(year);
    }, [year])

    useEffect(() => {
        const newOptions = options?.education_levels?.map((opt, index) => 
        ({
            ...opt,
            id: index + 1,
            xp_key: options?.data?.find(tr => (tr.education_level == opt.education_level && tr.prep_struc_category_id == opt.prep_struc_category_id))?.xp_key,
            date_from: moment(
                options?.data?.find(tr => (tr.education_level == opt.education_level && tr.prep_struc_category_id == opt.prep_struc_category_id))
                ?.date_from || null)
                .format(dateFormat),
            date_to: moment(
                options?.data?.find(tr => (tr.education_level == opt.education_level && tr.prep_struc_category_id == opt.prep_struc_category_id))
                ?.date_to || null)
                .format(dateFormat),
            trmids: options
                            ?.data
                            ?.filter(tr => (tr.education_level == opt.education_level && tr.prep_struc_category_id == opt.prep_struc_category_id))
                            ?.map(tr => ({...tr, isChecked: true})),
        })
        )

        setOptionsLocal(newOptions);
        // getGrantsOptions(year);
    }, [options])

    const handleChange = (level, target, element) => {
        const {name, value} = target;
        let date_from;
        if (element.prep_struc_category == 'Курсант') {
            date_from = moment(value).subtract(2, 'year').format(dateFormat);
        } else if (element.prep_struc_category == 'Слушатель') {
            date_from = moment(value).subtract(1, 'year').format(dateFormat);
        } else if (element.prep_struc_category == 'Адъюнкт') {
            date_from = moment(value).subtract(1, 'year').format(dateFormat);
        } else if (element.prep_struc_category == 'СПО') {
            date_from = moment(value).subtract(1.5, 'year').format(dateFormat);
        }

        const _date_from = moment(date_from).set('date', 1).set('month', 8).format(dateFormat);
        const newOptionsLocal = [...optionsLocal];
        newOptionsLocal[level][name] = value;
        newOptionsLocal[level].date_from = _date_from;

        handleGetTerms(element.id, {
            date_from: newOptionsLocal[level].date_from,
            date_to: newOptionsLocal[level].date_to});

        setOptionsLocal(newOptionsLocal);
    };

    const handleClose = () => {
        setIsPopup(false)
        store.dispatch({type: GRANTS_OPTIONS, payload: []});
        setOptionsLocal(null)
    }

    useEffect(() => {
        const close = (e) => {
          if(e.keyCode === 27){
            handleClose();
          }
        }
        window.addEventListener('keydown', close)
      return () => window.removeEventListener('keydown', close)
    },[])
    
    const handleSubmit = () => {
        const newOptionsLocal = [...optionsLocal];
        const newOptions = newOptionsLocal.map(el => ({
            ...el,
            trmids: el.trmids.filter(trm => trm.isChecked === true)}));

        if (newOptions.find(el => el?.date_from == null) || newOptions.find(el => el?.date_from == ''))  return createNotification('error', 'Заполните поля "Дата от"');
        if (newOptions.find(el => el?.trmids.length == 0)) return createNotification('error', 'Выберите хотя бы один триместр для уровней образования');

        setIsPopup(false)
        editGrantsOptions(newOptions, year)
        store.dispatch({type: GRANTS_OPTIONS, payload: []});
        setOptionsLocal(null);
    }

    const handleSaveTerms = () => {
        setIsTermPopup(null)
    }

    const handleChangeTerms = (id, trmid) => {
        setOptionsLocal(prev => 
            prev.map(options => options.id === id ? {...options, 
                'trmids': options.trmids.map(el => el.trmid == trmid ? ({...el, isChecked: !el.isChecked}) : el)
            
            } : options
        ))
    };

    const handleCheckDate = (date) => {
        if (date != null && date != '' && date != 'Invalid date') {
            return false;
        } else {
            return true;
        }
    }

    const handleIsTermPopup = (index, element) => {
        if (handleCheckDate(element.date_to)) {
            createNotification('error', 'Заполните поле "Дата до"');
        } else {
            getGrantsTerms(element.id, {date_to: element.date_to});
            setIsTermPopup(index);
        }
    }

    const handleReset = () => {
        store.dispatch({type: GRANTS_OPTIONS, payload: {
            ...options,
            data: []
        }});
    }

    return (
        <div className={styles.popup}>
            <div className={styles.wrapper}>
                <div className={styles.inner}>
                    <p className={styles.title}>Настройки параметров для видов стипендий
                    <div className={styles.selector}>
                    <Selector
                        label=''
                        width='300px'
                        options={[...yearsLocal]}
                        onChange={(e) => setYear(e)}
                        value={year}/>
                    </div>
                    <div className={styles.button} onClick={handleReset}>Сброс</div>
                    </p>
                    <Loader loaded={!loading_options} color='grey'>
                    <div className={styles.tableWrapper}>
                    {year !== '0' ? <table className={styles.table}>
                        <thead>
                            <tr>
                                <th rowSpan={2}>Уровень подготовки</th>
                                <th rowSpan={2}>Период промежуточной аттестации для расчета среднего балла</th>
                                <th colSpan={2}>Периоды достижений</th>
                            </tr>
                            <tr>

                                <th rowSpan={1}>Дата начала</th>
                                <th rowSpan={1}>Дата окончания</th>
                            </tr>
                        </thead>
                        <tbody>
                            {optionsLocal?.map((element, index) => 
                            <tr key={index}>
                            <td
                                style={{
                                fontWeight: '700'
                            }}>{educationLevelsReNames[element.prep_struc_category]}</td>
                            <td
                                style={{
                                width: '40%',
                                position: 'relative'
                            }}>
                                {element.trmids?.filter(trm => trm.isChecked)
                                ?.map((item, index) => index !== 0 ? ', ' + item.title : item.title)}
                                        {isTermPopup == index+1 ? (
                                    <div className={styles.termsPopup}>
                                        <div className={styles.termsPopupInner}>
                                            {element.trmids
                                                ?.map(({title, trmid, isChecked}) => 
                                                <div 
                                                    className={styles.termsPopupItem} 
                                                    key={trmid}
                                                    onClick={(e) => handleChangeTerms(element.id, trmid)}
                                                    >
                                                    <input
                                                        type="checkbox"
                                                        name="trmids"
                                                        checked={isChecked}
                                                        value={trmid}/> {title}
                                                </div>)
}
                                        </div>

                                        <div className={styles.termsPopupBtns}>
                                            <div className={styles.termsPopupBtn} onClick={handleSaveTerms}>Ок</div>
                                        </div>
                                    </div>
                                ): null}
                                <div onClick={() => handleIsTermPopup(index+1, element)} className={styles.termsBtn}>Изменить</div>
                            </td>

                            <td style={{backgroundColor: '#c5c5c5'}}>
                                <input
                                style={{backgroundColor: '#c5c5c5'}}
                                disabled
                                value={optionsLocal?.[index]?.date_from}
                                type="date"
                                name='date_from'
                                className={styles.inputDateFrom}
                                /></td>
                            <td><input
                                value={optionsLocal?.[index]?.date_to}
                                type="date"
                                name='date_to'
                                className={styles.inputDateTo}
                                onChange={(e) => handleChange(index, e.target, element)}
                                /></td>
                        </tr>
                            )}
                        </tbody>
                    </table> : <></>}
                    </div>
                </Loader>
                </div>

                <div className={styles.buttons}>
                    <div className={styles.buttonClose} onClick={handleClose}>Закрыть</div>
                    <div className={styles.button} onClick={handleSubmit}>Сохранить</div>
                </div>
            </div>
        </div>
    )
}

export default connect(mapStateToProps, {getGrantsTerms, getGrantsOptions, editGrantsOptions})(Index)